import { render, staticRenderFns } from "./Genou.vue?vue&type=template&id=2b4e1300&scoped=true&"
import script from "./Genou.vue?vue&type=script&lang=js&"
export * from "./Genou.vue?vue&type=script&lang=js&"
import style0 from "./Genou.vue?vue&type=style&index=0&id=2b4e1300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e1300",
  null
  
)

export default component.exports